import React, { useCallback } from 'react';
import { FlatList, StyleSheet, View, } from 'react-native';
import { NativeViewGestureHandler } from 'react-native-gesture-handler';
import { CardView } from 'design-system/CardView';
import { rem } from 'design-system/values';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import LearnArticleCard from './LearnArticleCard';
import SectionHeader from '../../../invest/components/SectionHeader';
import { isWeb } from '../../../../constants';
const LearnArticlesSection = ({ contentContainerStyle, learnArticles, }) => {
    const { navigateDeprecated } = useMainStackNavigation();
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const renderItem = useCallback(({ item, index }) => (<LearnArticleCard data={item} key={index} fullWidth={learnArticles?.length === 1}/>), [learnArticles]);
    const onSeeMorePress = useCallback(() => {
        navigateDeprecated('LearnArticles', { learnArticles });
    }, [learnArticles]);
    const displayedArticles = isWeb ? learnArticles.slice(0, 3) : learnArticles;
    if (!learnArticles?.length) {
        return null;
    }
    return (<>
      <SectionHeader title="Articles" {...(learnArticles?.length > 1 && {
        onSeeMorePress: () => onSeeMorePress(),
    })} style={contentContainerStyle}/>
      {isWeb ? (<View style={paddingHorizontalStyle}>
          <CardView webPadding noMarginTop noMarginBottom>
            {displayedArticles.map((article) => (<LearnArticleCard key={article.url} data={article} forList fullWidth/>))}
          </CardView>
        </View>) : (<NativeViewGestureHandler disallowInterruption>
          <FlatList scrollEnabled={learnArticles?.length > 1} horizontal data={learnArticles} initialNumToRender={3} renderItem={renderItem} style={styles.overflowVisible} keyboardShouldPersistTaps="handled" showsHorizontalScrollIndicator={false} contentContainerStyle={[
                styles.containerStyles,
                contentContainerStyle,
            ]}/>
        </NativeViewGestureHandler>)}
    </>);
};
export default React.memo(LearnArticlesSection);
const styles = StyleSheet.create({
    containerStyles: {
        paddingHorizontal: rem(12),
    },
    overflowVisible: {
        overflow: 'visible',
    },
});
